<template>
    <div id="login" class="text-center">
        <b-container>
            <b-row align-v="center" align-h="center">
                <b-col cols="12" class="text-center">
                    <div>
                        <b-form @submit="onRegister" v-if="show" class="form-signin">
                            
                            <h3 class="h3 mb-3 font-weight-normal text-left"> 
                                 Cadastro
                            </h3>
                            <h5 v-if="error">As senhas devem ser iguais</h5>
                            <h5 v-if="success">Usuario cadastrado com sucesso</h5>

                            <b-form-group label-for="input-1">
                                <b-form-input
                                id="input-1"
                                v-model="userData.email"
                                type="email"
                                required
                                placeholder="Digite seu email"
                                class="form-control"
                                ></b-form-input>
                            </b-form-group>

                            <b-form-group label-for="input-2">
                                <b-form-input
                                id="input-2"
                                v-model="userData.username"
                                type="text"
                                required
                                placeholder="Digite seu username"
                                class="form-control"
                                ></b-form-input>
                            </b-form-group>

                            <b-form-group label-for="input-3">
                                <b-form-input
                                id="input-3"
                                v-model="userData.password"
                                type="password"
                                required
                                placeholder="Digite uma senha"
                                class="form-control"
                                ></b-form-input>
                            </b-form-group>

                            <b-form-group label-for="input-4">
                                <b-form-input
                                id="input-4"
                                v-model="userData.passwordConfirmation"
                                type="password"
                                required
                                placeholder="Confirmar senha"
                                class="form-control"
                                ></b-form-input>
                            </b-form-group>

                            <b-button type="submit" variant="primary" class="btn-block">Cadastrar</b-button>

                        </b-form>                     
                    </div>
                     <div class="text-center">
                        <router-link to="/login" style="color: rgba(255,255,255, .75)">Já tenho uma conta</router-link>
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <!-- <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSda14-T9TKjlknl8_oexzZwxKr1S1LV78c4K3I__hwPfZlBvA/viewform?embedded=true" width="100%" height="1850
                    " frameborder="0" marginheight="0" marginwidth="0">Carregando…</iframe>                   -->

    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'Signup',
    data() {
        return {
            userData: {
                username: '',
                password: '',
                passwordConfirmation: '',
                email: '',
                name: ''
            },
            show: true,
            error: false,
            success: false
        }
    },
    methods:
        { 
            onRegister(evt) {
                if( this.userData.password === this.userData.passwordConfirmation ) {
                    this.$store.dispatch('register', this.userData);
                    this.success=true;
                    evt.preventDefault();
                }
                else {
                    this.error=true;
                    evt.preventDefault();
                }
            },
        },
    computed: mapState(['user']),
    created() {}
}
</script>

<style scoped>
#input-1, #input-2 {
    border: none;
    border-bottom: 1px solid aqua;
}

button a {
    color: rgba(255, 255, 255, .9);
}
button:hover a {
    color: rgba(255, 255, 255, .6);
    transition: .5s;
    text-decoration-line: none;
}

#login {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  height: inherit;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}


</style>